module.exports = ".bs-example{\r\n    margin: 20px;\r\n}\r\n"